package br.com.htms.inspeccaocampo.data

/**
 * Relatorio de seguranca (PPTX mensal) — 1 dossie por obra/ano/mes.
 */
data class RelSegDadosGerais(
    val empresa: String = "Htms Energia",
    val cnpj: String = "",
    val grauRisco: String = "",
    val obra: String = "",
    val contrato: String = "",
    val vigencia: String = "",
    val cliente: String = "",
    val efetivoHtms: String = "",
    val efetivoTerceiro: String = ""
)

data class RelSegGestaoSms(
    val desviosGerais: Int? = null,
    val apr: String = "",
    val pt: String = "",
    val dds: String = "",
    val treinamentos: String = "",
    val checklist: String = "",
    val acidentesFatais: Int? = null,
    val acidentes: Int? = null,
    val lesoes: Int? = null,
    val quaseAcidentes: Int? = null
)

data class RelSegDdsEntry(
    val temaData: String = "",
    val fotoRef: String = ""
)

data class RelSegTreinamento(
    val treinamento: String = "",
    val nomes: String = "",
    val data: String = "",
    val numPessoas: String = "",
    val descricao: String = "",
    /** R2 keys (rel-seg/dossiers/...) — até 4 fotos no grid 2×2 do PPTX. */
    val fotos: List<String> = List(4) { "" }
) {
    fun withFotosSize(): RelSegTreinamento {
        val list = fotos.toMutableList()
        while (list.size < 4) list.add("")
        return copy(fotos = list.take(4))
    }
}

data class RelSegPayload(
    val dadosGerais: RelSegDadosGerais = RelSegDadosGerais(),
    val gestaoSms: RelSegGestaoSms = RelSegGestaoSms(),
    val dds: List<RelSegDdsEntry> = List(30) { RelSegDdsEntry() },
    val treinamentos: List<RelSegTreinamento> = List(3) { RelSegTreinamento() }
) {
    fun withDdsSize(): RelSegPayload {
        val list = dds.toMutableList()
        while (list.size < 30) list.add(RelSegDdsEntry())
        return copy(dds = list.take(30))
    }

    fun withTreinamentosSize(): RelSegPayload {
        val list = treinamentos.toMutableList()
        while (list.size < 3) list.add(RelSegTreinamento())
        return copy(treinamentos = list.map { it.withFotosSize() }.take(3))
    }
}

data class RelSegDossier(
    val id: String,
    val userId: String? = null,
    val username: String? = null,
    val obra: String,
    val ano: Int,
    val mes: Int,
    val payload: RelSegPayload = RelSegPayload(),
    val createdAt: Long? = null,
    val updatedAt: Long? = null
)

data class FormRelatorioSeguranca(
    val dossierId: String? = null,
    val obra: String = "",
    val ano: Int = 2026,
    val mes: Int = 1,
    val payload: RelSegPayload = RelSegPayload(),
    val dirty: Boolean = false,
    val lastSyncedAt: Long? = null,
    val readOnly: Boolean = false
)

object RelSegMeses {
    val rotulos = RemMeses.rotulos
    fun rotulo(mes: Int): String = RemMeses.rotulo(mes)
}